














































































































































































































































































import mutations from "@/gql/mutations.coffee"
import queries from "@/gql/queries.coffee"
import settings from "@/settings.coffee"
import ConnectionInfo from '@/components/ConnectionInfo.vue'
import DropDown from '@/components/DropDown'
import gql from '@/gqlService.coffee'
import m from "@/gql/mutations.coffee"
import moment from "moment"
import MyFlag from "@/components/MyFlag.vue"

export default {
    "name": "ReviewDetail",
    "props": {
        review: Object
        showPad: Boolean
    }
    "components":{
        ConnectionInfo
        DropDown
        MyFlag
    }
    "data": ()->
        backendUrl: settings.backendMediaUrl
        show_native: false
        show_conn: false
        conn_info: null
        langs: []
        show_details: false
        details: {}
        field_labels: null
        consultants: gql.query({
            "model": "consultant_set"
            "fields": "uid lastname firstname fullname"
        })
        hovered: false,
    "methods":
        "show_more": ()->
            this.show_details = !this.show_details
        "to_clean_date": (date)->
            return moment(date).format("MMMM YYYY");
        "to_clean_date2": (date)->
            return moment(date).format("LLL");
        "to_clean_date3": (date)->
            return moment(date).format("LL");
        "open_trad": ()->
            window.open('%2B + aa')
        "consultantClicked": (arg)->
            m.run('update_review_answerer', [@review.uid, arg.uid])
            return
        "toggle_thumb": ()->
            new_value = !@review.positive
            data = await @$http.post(settings.graphqlApiUrl, {query: mutations.gql_mutation_review_update_positive(@review.uid, new_value)})
        "reloadDetails": ()->
            vm = this
            queries.run('get_review_details',[@review.uid]).then (resp)->
                vm.details = resp.body.data.review_details
        "reloadConnection": ()->
            self = @
            queries.run('get_connection_for', [@review.platform.uid, @review.establishment.uid]).then (resp)->
                if resp.data.data.connection_set.length > 0
                    self.conn_info = resp.data.data.connection_set[0]
                else
                    self.conn_info = null
        "updateLang": ()->
            ret = await mutations.run("update_review_lang", [@review.uid, @review.native_lang.uid])
        "save_text": ()->
            response = await mutations.run(
                "update_review_text_fr",
                [@review.uid, @review.text_fr, @review.title_fr])
        "closeListener": (e)->
            vm = @
            selected = vm.$el.querySelector(".show-conn-button")
            if selected and not selected.contains(e.target)
                vm.show_conn = false
            return
        "copyInPaperWeight": (refName)->
            el = @$refs[refName]
            text = if el.tagName.toLowerCase() == 'textarea'
                el.value
            else
                el.textContent

            navigator.clipboard.writeText(text)
                .then =>
                    @$store.dispatch("notify",{
                        level: "success",
                        text: "Copié!",
                        seconds: 2
                    })
                .catch (err) =>
                    @$store.dispatch("notify",{
                        level: "error",
                        text: "Erreur lors de la copie",
                        seconds: 2
                    })
    "filters":
        "remove_newline": (txt)->
            if txt
                return txt.replace("\\n"," ")
            return txt
        "fix_newline": (txt)->
            if txt
                return txt.replace("\\n","\n")
            return txt
    "computed":
        "detail_fields": ()->
            ret = []
            for key in Object.keys(this.details)
                if key != 'platform' and key != "scraped_on"
                    value = this.details[key]
                    if value == "True" or value == "true" or value == true
                        value = "Oui"
                    else if value == "False" or value == "false" or value == false
                        value = "Non"
                    if value and key.indexOf('note_') >= 0
                        value+="/10"
                    if @field_labels?
                        ret.push({
                            'value': value,
                            'label': this.field_labels[key]
                        })

            return ret
        "details_info_count": ()->
            ret = 0
            for key in Object.keys(this.details)
                if this.details[key] != "" and this.details[key] != null and key != 'platform' and key != "scraped_on"
                    ret += 1
            return ret
        "google_translate_link": ()->
            if !@review.text_native?
                @review.text_native = ""
            text = @review.text_native.replace(/&/g, " ").replace(/\n/g, "%0A").replace(/\+/g, "%2B")
            if !@review.title_native?
                @review.title_native = ""
            text = @review.title_native + "%0A%0A" + text
            return 'https://translate.google.fr/?sl=auto&tl=fr&op=translate&text=' + text
        "deeple_translate_link": ()->
            if !@review.text_native?
                @review.text_native = ""
            text = @review.text_native.replace(/&/g, " ")\
                .replace(/\%/g, "%25")\
                .replace(/\n/g, "%0A")\
                .replace(/\+/g, "+")\
                .replace(/\//g, "%E2%88%95")
            if !@review.title_native?
                @review.title_native = ""
            title = @review.title_native.replace(/&/g, " ")\
                .replace(/\%/g, "%25")\
                .replace(/\n/g, "%0A")\
                .replace(/\+/g, "+")\
                .replace(/\//g, "%E2%88%95")
            text = title + "%0A%0A" + text
            return 'https://www.deepl.com/translator#' +\
                @review.native_lang.code.toLowerCase()+'/fr/' +\
                text

        "native_lang_code": ()->
            return @review.native_lang.code.toLowerCase()
        "thumb_color_class": ()->
            return {
                "bg-success": @review.positive == true,
                "bg-danger": @review.positive == false,
            }
        "thumb_class": ()->
            return {
                "bi-hand-thumbs-up first": @review.positive == true,
                "bi-hand-thumbs-down second": @review.positive == false,
            }
        "toggle_thumb_color_class": ()->
            return {
                "bg-success": @review.positive == false,
                "bg-danger": @review.positive == true,
        }
        "toggle_thumb_class": ()->
            return {
                "bi-hand-thumbs-up first": this.review.positive == false,
                "bi-hand-thumbs-down second": this.review.positive == true,
            }
        "answerer": ()->
          ret = {uid: null, fullnale: null}
          if @review.answerer
            ret = @review.answerer
          return ret
    "watch":
        "review.uid": (newV)->
            @reloadConnection()
            @reloadDetails()
        #"review.native_lang.uid": (newV, oldV)->
        #    console.log("review.native_lang.uid", newV, oldV)
        #    @updateLang()
    "mounted": ()->
        self = @
        document.addEventListener("click", self.closeListener, true)
        @reloadConnection()
        @reloadDetails()
        queries.run('get_langs',[])
        .then (resp)->
            ret = resp.body.data.lang_set
            self.langs = ret
        queries.run('get_fields_label',['review.review'])
        .then (resp)->
            field_labels = {}
            for f in resp.body.data.fields_label_set
                field_labels[f.name] = f.verbose_name
            self.field_labels = field_labels
    "beforeDestroy": ()->
        vm = @
        ret = document.removeEventListener('click', vm.closeListener, true)
}
